export const SUB_MENU_SIDE_OFFSET = 8;
export const SUB_MENU_ALIGN_OFFSET = -2;
